import { OnInit, Component, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { TrucksService, Truck } from 'src/app/transportation/trucks/trucks.service';
import { forkJoin } from 'rxjs';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import moment from 'moment';
import { PgTitleComponent } from '../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';
import { DateTimeHelpers } from 'src/app/shared/helpers/date-time.helpers';

@Component({
  templateUrl: 'tracker-monitor-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, AgGridModule],
})
export class TrackerMonitorListComponent implements OnInit, PgTitleComponent {

  title = new EventEmitter<string>();

  trucks: Truck[] = [];

  outliersCash: { [key: string]: any[] } = {};

  _organisationsCache: { [key: string]: Organisation } = {};

  gridOptions: GridOptions = {};

  constructor(private _trucksService: TrucksService,
    private _organisationService: OrganisationService) { }

  columnDefs = [
    { headerName: 'شماره پلاک', field: 'formattedRegistrationNumber' },

    {
      headerName: 'شماره مخزن', field: 'tanker.associatedObject.number',
      cellRenderer: (params: any) => (params.data.tanker) ? params.data.tanker.associatedObject.number : '',
    },

    {
      headerName: 'نام راننده', field: 'driver.associatedObject.name',
      cellRenderer: (params: any) => (params.data.driver) ? params.data.driver.associatedObject.name : '',
    },

    {
      headerName: 'شماره ردیاب', field: 'tracker.associatedObject.imei',
      cellRenderer: (params: any) => (params.data.tracker) ? params.data.tracker.associatedObject.imei : '',
    },

    {
      headerName: 'شرکت حمل و نقل', field: 'organisationId.associatedObject',
      valueFormatter: (params: any) => this.formatOrganisation(params.value),
      filterValueGetter: (params: any) => this.formatOrganisation(params.data.organisationId.associatedObject),
    },

    {
      headerName: 'آخرین به روز رسانی', field: 'lastLocation',
      cellRenderer: (params: any) => (params.data.lastLocation) ? DateTimeHelpers.formatPersianLocalDateTime(params.data.lastLocation.time) : '',
    },

    {
      headerName: 'وضعیت دسترسی',
      cellRenderer: (params: any) => {
        const status = this.isTruckOutdated(params.data);
        if (status === 'خارج از دسترس') {
          return `<span style="color:red">${status}</span>`;
        } else if (status === 'در دسترس') {
          return `<span style="color:green">${status}</span>`;
        }
        return status;
      }
    },

    { headerName: 'دفعات قطعی', cellRenderer: (params: any) => this.getOutlierLocations(params.data) ?? '-' },
    { headerName: 'وضعیت فعالیت', field: 'active' },
  ];

  ngOnInit(): void {
    this.title.emit('Tracker Monitoring');
    this.gridOptions = AgGridService.getOptions();
    const startDate = moment().startOf('day').subtract(2, 'd').toDate().getTime();
    const endDate = moment().endOf('day').toDate().getTime();
    forkJoin([
      this._organisationService.get(),
      this._trucksService.getForLpgDist(),
      this._trucksService.getOutlierLocations(startDate, endDate)
    ]).subscribe(result => {
      result[0].forEach(o => {
        this._organisationsCache[o.name] = o;
      });
      this.trucks = result[1].filter(truck => truck.tracker && truck.tracker.associatedObject.imei !== '');
      this.outliersCash = result[2].reduce((hashMap: Record<string, any>, outliers: any) => {
        hashMap[outliers[0]] = outliers[1];
        return hashMap;
      }, {});
    });
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  isTruckOutdated(truck: Truck) {
    const outDated = this._trucksService.isPositionOutdated(truck);
    if (truck.tracker && truck.tracker.associatedObject.imei !== '') {
      if (outDated) {
        return 'خارج از دسترس';
      } else {
        return 'در دسترس';
      }
    } else {
    }
  }

  formatOrganisation(organisationId: string) {
    const foundOrganisation = this._organisationsCache[organisationId];
    if (foundOrganisation) {
      return foundOrganisation.nameTranslations['fa'];
    } else {
      return '';
    }
  }

  getOutlierLocations(truck: Truck) {
    if (truck.tracker !== undefined && this.outliersCash[truck.tracker!.associatedObject.imei]) {
      return this.outliersCash[truck.tracker!.associatedObject.imei].length;
    } else {
      return null;
    }
  }
}
